module.exports = {"ruyi-group":"如意集团","ruyi-group2":"如 意 集 团","locale":{"cn":"中文","en":"EN"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/messages/cn/common.json
// module id = 644
// module chunks = 1